<script setup lang="ts">
import { useField } from 'vee-validate'

const ccData = [
  { code: 'cn', dialCode: '+86' },
  // { code: 'us', dialCode: '+1' }
]

const { t } = useI18n()
const { t: lt } = useI18n({ useScope: 'local' })

const props = defineProps<{
  showCodeInput: boolean,
}>()

const emit = defineEmits<{
  (e: 'codeResendDelayed', delayed: boolean): void
}>()

interface State {
  resendDelay: number
}

const state: State = reactive({
  codeSent: props.showCodeInput,
  resendDelay: 0,
})

const { value: countryCode } = useField(() => 'countryCode')

const {
  value: mobileNumber,
  errorMessage: mobileNumberError,
  validate: validateMobileNumber
} = useField(() => 'mobileNumber')
const {
  value: mobileCode,
  errorMessage: mobileCodeError
} = useField(() => 'mobileCode')

const fieldLabel = computed(() => {
  return props.showCodeInput ? t('mobile_otp.code') : t('mobile_otp.mobile_number')
})

async function codeResend() {
  emit('codeResendDelayed', true)
  state.resendDelay = 30

  const mobileDelayInterval = setInterval(() => {
    state.resendDelay -= 1
    if (state.resendDelay <= 0) {
      clearInterval(mobileDelayInterval)
      emit('codeResendDelayed', false)
    }
  }, 1000)
}
</script>

<template>
  <div class="form-field">
    <FormField
      v-show="!props.showCodeInput"
      :label="fieldLabel"
    >
      <div class="field-inline">
        <select v-model="countryCode" class="prefix">
          <option v-for="entry of ccData" :value="entry.dialCode">
            {{ `${lt(`countries.${entry.code}`)} ${entry.dialCode}` }}
          </option>
        </select>
        <input v-model="mobileNumber" type="text" name="mobileNumber" />
        <div v-if="state.resendDelay > 0" class="resend-delay">
          ({{  state.resendDelay  }})
        </div>
      </div>
    </FormField>
    <FormField
      v-show="props.showCodeInput"
      :label="fieldLabel"
    >
      <div class="field-inline">
        <input v-model="mobileCode" type="text" name="mobileCode" />
        <button @click.prevent="codeResend" class="button small">
          {{ $t('mobile_otp.resend') }}
        </button>
      </div>
    </FormField>
    <div v-if="mobileNumberError || mobileCodeError" class="error">
      <template v-if="mobileNumberError">{{ mobileNumberError }}</template>
      <template v-if="mobileCodeError">
        {{ mobileCodeError }}
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .resend-delay {
    padding: 0.5rem;
    background-color: rgba(0, 0, 0, 0.1);
  }
</style>

<i18n lang="json">
  {
    "en": {
      "countries": {
        "cn": "China",
        "us": "USA"
      }
    },
    "zh-cn": {
      "countries": {
        "cn": "中国",
        "us": "美国"
      }
    }
  }
</i18n>
